import dynamic from 'next/dynamic';
import { FC } from 'react';
import { MimeType } from '../../helpers/file/mime-types';

// Dynamic import required since client side rendering is mandatory!
const PDFPreview = dynamic(() => import('@components/common-layout/PdfPreview/PdfPreview'), {
  ssr: false,
});
const DocxPreview = dynamic(() => import('@components/common-layout/DocxPreview/DocxPreview'), {
  ssr: false,
});

interface FilePreviewProps {
  fileUrl: string;
  mimeType: MimeType;
  requiresAuthentication?: boolean;
}

/**
 * Dedicated component to be used for any type of file previews e.g. pdf/docx.
 *
 * @param fileUrl - Complete url including protocol
 * @param mimeType - file mime type
 * @param requiresAuthentication - if set to true (and if supported by internal component) an Authorization header will be attached when fetching the file
 */
export const FilePreview: FC<FilePreviewProps> = ({
  fileUrl,
  mimeType,
  requiresAuthentication,
}) => {
  let preview = <div>Not available</div>;

  switch (mimeType) {
    case MimeType.PDF:
      preview = <PDFPreview pdfUrl={fileUrl} requiresAuthentication={requiresAuthentication} />;
      break;
    case MimeType.MicrosoftWordOpenXML:
      preview = <DocxPreview docxUrl={fileUrl} requiresAuthentication={requiresAuthentication} />;
      break;
    // Extend if needed
  }

  return preview;
};
